import React, { Suspense } from 'react'
import { Routes } from './routes/Routes'
import { Provider } from 'react-redux';
import generateStore from './store/store';

/* Traducciones */
import './i18n';

import '@amcharts/amcharts4/charts';

import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { JoyrideProvider} from './context/Joyride';
import { IdSegundoNivelProvider } from './context/IdSegundoNivelContext'; // Importa el proveedor del contexto
import { PagesProvider } from './context/PagesContext'; // Importa el proveedor de PagesContext
import { ChatProvider } from './context/ChatContext'; // Importa el proveedor de ChatContext
import { AuthChatIntegration } from './components/chat/AuthChatIntegration'; // Importa la integración auth-chat

am4core.useTheme(am4themes_animated);

am4core.addLicense("CH275678482");




export const App = () => {
  const store = generateStore()
  return (

    <Provider store={store}>
      <JoyrideProvider>
        <IdSegundoNivelProvider>
          <PagesProvider> {/* Envuelve con PagesProvider */}
            <ChatProvider>
              <AuthChatIntegration /> {/* Componente de integración auth-chat */}
              <Suspense fallback={null}>
                <Routes />
              </Suspense>
            </ChatProvider>
          </PagesProvider>
        </IdSegundoNivelProvider>
      </JoyrideProvider>
    </Provider>
  );
}
